module.exports = require('./helpers/bundle-url').getBundleURL('7ucCx') + "logo.c51670a8.svg";